import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function getServiceUrl(cloudId, baseUrlOverride) {
  var path = "/gateway/api/watermelon/workspace/existsWithWorkspaceType?cloudId=".concat(cloudId);
  if (baseUrlOverride) {
    return "".concat(baseUrlOverride).concat(path);
  }
  return path;
}
export function isGlobalExperienceWorkspaceForCloudId(_x, _x2) {
  return _isGlobalExperienceWorkspaceForCloudId.apply(this, arguments);
}
function _isGlobalExperienceWorkspaceForCloudId() {
  _isGlobalExperienceWorkspaceForCloudId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(cloudId, baseUrlOverride) {
    var response, workspaceType;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return fetch(getServiceUrl(cloudId, baseUrlOverride), {
            credentials: 'include'
          });
        case 3:
          response = _context.sent;
          if (!response.ok) {
            _context.next = 9;
            break;
          }
          _context.next = 7;
          return response.text();
        case 7:
          workspaceType = _context.sent;
          return _context.abrupt("return", workspaceType === 'GLOBAL_EXPERIENCE');
        case 9:
          return _context.abrupt("return", false);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", false);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 12]]);
  }));
  return _isGlobalExperienceWorkspaceForCloudId.apply(this, arguments);
}